import {
  SEND_OTP_RESPONSE,
  MOBILE_NO_LOGIN_RESPONSE,
  GOOGLE_LOGIN_RESPONSE,
  FACEBOOK_LOGIN_RESPONSE,
} from "./actionTypes";
import { setLoggeedInUser } from "../../../helpers/authUtils";

import produce from "immer";

export const initialState = {
  loginApiResponse: null,
  loginUser: null,
  loginMobileNo: null,
};

const login = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GOOGLE_LOGIN_RESPONSE:
      case FACEBOOK_LOGIN_RESPONSE:
      case MOBILE_NO_LOGIN_RESPONSE:
        const apiResponse = action.payload.apiResponse;
        draft.loginApiResponse = action.payload.apiResponse;
        if (apiResponse.isSuccessResponse) {
          setLoggeedInUser(apiResponse.responseData);
          draft.loginUser = apiResponse.responseData;
          draft.loginMobileNo = null;
        }
        break;

      case SEND_OTP_RESPONSE:
        draft.loginApiResponse = action.payload.apiResponse;
        draft.loginMobileNo = action.payload.loginMobileNo;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default login;
